<template>

    <div class="booking">

        <div class="booking-img">
            <img id="classes" alt="Yoga By Ian" src="../../assets/images/yoga-studio-0.1.png">
        </div>

        <div class="booking-text">

            <img :src="require('../../assets/headers/class-booking-' + $i18n.locale + '.png')">

            <p>
                {{ $t('txtBookings') }}
            </p>
            <p><a href="https://www.moreleisure.com/loughborough-leisure-centre/facilities/workout-classes/" target="_blank">Loughborough Leisure Centre, Browns Lane, Loughborough. LE11 3HE</a></p>
            <p><a href="https://www.lboro.ac.uk/sport/online-bookings/" target="_blank">Holywell Fitness Centre, Loughborough University. LE11 3QF</a></p>
            <p><a href="https://www.lboro.ac.uk/sport/online-bookings/" target="_blank">Sir David Wallace Studios, Loughborough University. LE11 3TU</a></p>
            <p><a href="https://www.nottingham.ac.uk/sport/bookings-and-timetables/classes/" target="_blank">Sutton Bonington Sports Centre, University of Nottingham Sport. LE12 5RD</a></p>
            <p><a href="https://www.facebook.com/mykindoffitnessleics/" target="_blank">Yoga in Coalville, 1st Floor, Belvoir House, Belvoir Road, Coalville. LE67 3PN</a></p>

        </div>

    </div>

</template>
  
<script setup>

</script>

<style>

    .booking {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 30px;
        padding-left: 20px;
        padding-bottom: 40px;
        /* border: 2px dotted; */
    }

    .booking-text {
        flex: 1 1 200px;
        font-size: 18px;
        text-align: left;
        padding-top: 0px;
        padding-left: 20px;
        padding-right: 20px;
        /* border: 2px dotted; */
    }

    .booking-text img {
        width: 200px;
    }

    .booking-img {
        flex: 0 0 220px;
        padding-right: 0px;
        /* border: 2px dotted; */
    }

    .booking-img img {
        width: 320px;
        /* border: 2px dotted; */
    }

    @media screen and (max-width: 600px) {
        
        .booking {
            justify-content: center;
        }

        .booking-text {
            flex: 1 1 100px;
            font-size: 14px;
            text-align: left;
            padding-top: 0px;
            padding-left: 0px;
            padding-right: 20px;
            /* border: 2px dotted; */
        }
    }

</style>
